<template>
    <div class="container">
      <vue-element-loading background-color="#dcedff" size="128" spinner="bar-fade-scale"
                           color="#FF6700" text="Lütfen bekleyiniz..." :active="show" is-full-screen />
        <div style="width: 80vw; margin-left: 10vw">
            <survey v-if="survey !== null" :survey="survey"></survey>
            <footer>TOBB YAZILIM MÜDÜRLÜĞÜ @2020</footer>
        </div>
    </div>
</template>

<script>
import showdown from 'showdown'
import { StylesManager, Model } from "survey-vue";
import "survey-vue/defaultV2.css";
import * as SurveyCore from "survey-vue";
import * as widgets from "surveyjs-widgets";
StylesManager.applyTheme("defaultV2");
// Survey.cssType = 'modern'
let tr = SurveyCore
    .surveyLocalization
    .getLocaleStrings('tr');
// tr.completeText = '1231212321'
tr.noFileChosen = 'Dosya Seçilmedi'
tr.chooseFile = 'Dosya Seç'
tr.chooseFileCaption = 'Dosya Seç'
tr.cleanCaption = 'Temizle'
tr.clearCaption = 'Temizle'
tr.confirmRemoveFile = 'Dosyayı çıkartmak istediğinize emin misiniz?'
SurveyCore
    .surveyLocalization
    .locales["tr"] = tr
var converter = new showdown.Converter()
function doMarkdown (survey, options) {
  // convert the markdown text to html
  var str = converter.makeHtml(options.text)
  if (str.indexOf('<p>') === 0) {
    // remove root paragraphs <p></p>
    str = str.substring(3)
    str = str.substring(0, str.length - 4)
  }
  // set html
  options.html = str
}
// SurveyVue
//     .StylesManager
//     .applyTheme("darkblue");
// import * as widgets from 'surveyjs-widgets'

import { getOneURLAnket, saveAnketResultJSON, saveAnketResultWKisiJSON } from '../src/statics/axiosfuncs'

export default {
  name: 'AnketGoster',
  // components: {
  //   Survey
  // },
  computed: {},
  methods: {
    async getAnketDetail (kisaurl) {
      let kidi = this.$route.params.kisiid || null

      const anket = await getOneURLAnket(kisaurl, kidi)
      if (!anket) {
        this.$router.push('/hata')
      } else {
        if (anket.result === 1 ) {
          let t = this
          // const d = JSON.parse(anket.data.anketJSON)
            const d = anket.data.anketJSON
            this.survey = new Model(d)
            this.survey
                .onServerValidateQuestions.add(async function(survey, options){
                  // '.' kontrolü

                  let k = Object.keys(options.data)
                  const hatalilar = k.filter((v)=>{
                    return v.match(/[^0-9a-z ]/gi);
                  })
                  if (hatalilar.length > 0) {
                    options.errors[k[0]] = "Formda bir hata var, lütfen ilgili birim ile iletişime geçiniz.";
                    console.log(hatalilar)
                  }
                   options.complete();
               })
          this.survey
                .onTextMarkdown
                .add(doMarkdown)
            this.survey
                  .onComplete
                .add(async function (options) {
                  t.show = true
                  let r = null
                  if (anket.data.dosyadanKayit === true && t.$route.params.kisiid) {
                    r = await saveAnketResultWKisiJSON(t.$route.params.kisaurl, t.$route.params.kisiid, options.data)
                  } else {
                    r = await saveAnketResultJSON(t.$route.params.kisaurl,   options.data)
                  }
                  t.show = false
                  if (r.result === 0 ) {
                    t.$router.push({name: 'hata', params: {hata:'Bu anket Kaydedilemedi. Bir sistem arızası veya anketi daha önce doldurmuş olmanız buna sebep olmuş olabilir!' }})
                  }
                });
        } else {
          this.$router.push({name: 'hata', params: {hata:anket.err }})
        }
      }
      // this.$q.loading.hide()
    }
  },
  data () {
    widgets.select2(SurveyCore);
    widgets.select2tagbox(SurveyCore);
    widgets.inputmask(SurveyCore);
    widgets.jquerybarrating(SurveyCore);
    widgets.jqueryuidatepicker(SurveyCore);
    widgets.nouislider(SurveyCore);
    widgets.sortablejs(SurveyCore);
    widgets.ckeditor(SurveyCore);
    widgets.autocomplete(SurveyCore);
    widgets.bootstrapslider(SurveyCore);
    return {
      survey: null,
      show:false
    }
  },

  mounted () {
    if (this.$route.params.kisaurl || this.$route.params.kisaurl !== '') {
      this.getAnketDetail(this.$route.params.kisaurl)
    } else {
      this.$router.push('/hata')
    }
  }
}
</script>
<style>
input[type="file"] {
  display: none;
}
</style>
